<template>
  <div style="padding: 20px">
    支付结果查询中，请稍后!
  </div>
</template>

<script>
import { getUserRewardInfo } from '@/apis/ksForm';
import { Toast } from 'vant';

export default {
  name: 'KsActivityPayResult',
  data () {
    return {
      historyMobile: '',
      pollTimer: null,
      extraParams: {},
      isCheck: ''
    }
  },
  mounted () {
    this.historyMobile = localStorage.getItem("ksFormMobile") || '';
    this.extraParams = JSON.parse(localStorage.getItem('ksActivityQuery')) || {}
    this.isCheck = localStorage.getItem('ksFormActivityCheck')
    this.onCheckRewardRecord()
    
    this.startPollingCheck()
    // 后端那异步消费 支付结果有延迟，等到5秒后，如果没有查询到发放信息，则提示
    setTimeout(() => {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }, 5000)
  },
  methods: {
    // 检查是否有过领取记录
    onCheckRewardRecord () {
      if (this.historyMobile && this.extraParams.appkey && !this.isCheck) {
        getUserRewardInfo({
          mobile: this.historyMobile,
          gameId: this.extraParams.appkey
        }).then(res => {
          if (res.data) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
            // 有领过礼包码的时候，直接回到礼包码页面
            Toast('礼包码已发放')
            this.$router.push({
              path: '/ksForm/ksActivityGiftCode',
              query: {
                cdk: res.data.cdk
              }
            })
          }
        }).catch(() => {})
      }
    },

    startPollingCheck () {
      this.pollTimer = setInterval(this.onCheckRewardRecord, 1000)
    }
  }
}
</script>